<template>
  <div>
    <p>{{ label }} {{ objectClassification.toLowerCase() }} <strong>{{ details.event.name }}</strong> (<a :href="link">{{ objectClassification }}</a>)</p>
    <ul class="list-unstyled object-details">
      <li>Type: {{eventLabel}}</li>
      <li v-if="details.event.source">Source: {{ details.event.source.name }}</li>
      <li>{{ eventTiming }}</li>
      <li v-if="details.completed">{{ eventCompleted }}</li>
    </ul>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat)
export default {
  name: "FeedbackEvent",
  props: {
    details: {
      type: Object,
      default: function () {
        return {};
      }
    },
    label: {
      type: String,
      default: "Related to"
    }
  },
  inject: ['participantId'],
  methods: {
    formatDate(date) {
      return dayjs(date).format('MMM Do YYYY [at] h:mma');
    }
  },
  computed: {
    eventTiming() {
      if (this.details.start_date == this.details.end_date) {
        return "Ran at " + this.formatDate(this.details.start_date)
      } else {
        return "Window: Between "+this.formatDate(this.details.start_date)+" and "+this.formatDate(this.details.end_date);
      }
    },
    eventCompleted() {
      return "The participant completed this event on "+this.formatDate(this.details.completed_at)
    },
    objectClassification() {
      if (this.details.event.type.includes('TemplateEvent')) {
        return "Event";
      }
      if (this.details.event.type.includes('EnrollmentStep')) {
        return "Enrollment Step";
      }
    },
    eventLabel() {
      switch(this.details.event.type) {
        case 'VoiceConversationTemplateEvent':
          return 'Conversation Event';
        case 'DeviceTemplateEvent':
          return 'Collect Data Event';
        default:
          if (this.details.event.type.includes('TemplateEvent')) {
            return this.details.event.type.substr(0, this.details.event.type.indexOf('TemplateEvent')) + " " + this.objectClassification;
          }
          if (this.details.event.type.includes('EnrollmentStep')) {
            return this.details.event.type.substr(0, this.details.event.type.indexOf('EnrollmentStep')) + " " + this.objectClassification;
          }
      }
    },
    link() {
      return `${this.$config.baseUrl}/admin/study/${this.$config.studyId}/participants/${this.participantId}/event/${this.details.id}`
    }
  }
}
</script>

<style scoped>

</style>